import React, { useState } from "react";
import "./Recon.css";
import Modal from "./Modal";
import { IoMdAdd, IoMdRefresh } from "react-icons/io";
import { FaCheck, FaEye } from "react-icons/fa";
import { useSelector } from "react-redux";

function ReconTransaction({
  transactionDetails,
  setAddedDataForRecon,
  addedDataForRecon,
}) {
  const role = useSelector(store => store.userReducer.role);
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [forRender, setFoRender] = useState(false);

  const viewData = (item) => {
    setModalData(item);
    setOpenModal(true);
  };

  const addTransaction = (item) => {
    const itemExists = addedDataForRecon.some((i) => i.id === item.id);

    if (itemExists) {
      setAddedDataForRecon((prevData) =>
        prevData.filter((i) => i.id !== item.id)
      );
    } else {
      setAddedDataForRecon((prevData) => [...prevData, item]);
    }

    setFoRender((prev) => !prev);
  };

  return (
    <div className="table-main-report">
      <table className="table-user-management" id="transaction-table">
        <thead className="table-user-report">
          <tr>
            {role === "super" && (
              <td>
                <p className="user-table-head-report">Business Name</p>
              </td>
            )}
            <td>
              <p className="user-table-head-report">Amount(₹)</p>
            </td>
            <td className="filter-pos">
              <div className="data-icon">
                <p className="user-table-head-report">Status</p>
              </div>
            </td>
            <td>
              <p className="user-table-head-report">Date</p>
            </td>
            <td>
              <p className="user-table-head-report">Action</p>
            </td>
          </tr>
        </thead>

        <tbody>
          {transactionDetails &&
            transactionDetails.length > 0 &&
            transactionDetails.map((item) => {
              const dataItem = JSON.parse(item.request);
              const responseData = JSON.parse(item.resposne);
              item.dataItem = dataItem;
              item.responseData = responseData;

              const dateString = item.createdAt;
              const date = new Date(dateString);
              const day = date.getDate();
              const month = date.getMonth() + 1;
              const year = date.getFullYear();
              const formattedDate = `${day}-${month}-${year}`;
              const formattedTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

              return item.responseData.RESPONSE_STATUS === "INVALID" ? null : (
                <tr className="user-table-head-report" key={item.id}>
                  {role === "super" && (
                    <td>
                      <p className="table-user-data-report order-break">
                        {item.name || ""}
                      </p>
                    </td>
                  )}
                  <td>
                    <p className="table-user-data-report">
                      {item.dataItem.amount}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report">
                      {item.responseData.RESPONSE_STATUS}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report status-table">
                      {formattedDate} {formattedTime}
                    </p>
                  </td>
                  <td>
                    <div className="action-section">
                      <FaEye
                        style={{
                          width: "1.5rem",
                          height: "1.5rem",
                          fontWeight: "bold",
                        }}
                        onClick={() => viewData(item)}
                      />
                      <IoMdRefresh
                        style={{
                          width: "1.5rem",
                          height: "1.5rem",
                          fontWeight: "bold",
                        }}
                      />
                      <div>
                        {addedDataForRecon.some((i) => i.id === item.id) ? (
                          <FaCheck
                            style={{
                              width: "1rem",
                              height: "1rem",
                              fontWeight: "bold",
                              color: "green",
                            }}
                            onClick={() => addTransaction(item)}
                          />
                        ) : (
                          <IoMdAdd
                            style={{
                              width: "1.5rem",
                              height: "1.5rem",
                              fontWeight: "bold",
                            }}
                            onClick={() => addTransaction(item)}
                          />
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {openModal && modalData && (
        <Modal modalData={modalData} setOpenModal={setOpenModal} />
      )}
    </div>
  );
}

export default ReconTransaction;
